import { Box, Typography } from "@mui/material";
import { colorTextMuted, colorTextPrimary } from "src/design/tokens";

interface AccountRequestsHeaderProps {
  pendingCount: number;
}

export const AccountRequestsHeader = ({
  pendingCount,
}: AccountRequestsHeaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: 3,
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <Box>
      <Typography
        variant="h6"
        sx={{ fontWeight: 600, color: colorTextPrimary }}
      >
        Account Requests
      </Typography>
      {pendingCount > 0 && (
        <Typography variant="body2" sx={{ color: colorTextMuted, mt: 0.5 }}>
          {pendingCount} pending request{pendingCount > 1 ? "s" : ""} awaiting
          review
        </Typography>
      )}
    </Box>
  </Box>
);
